import { graphql } from 'react-relay';

/**
 * Slice-3 feature-toggle audit trail, newest first. The optional `flag` narrows
 * the read server-side to a single flag's history; vault / operator refinement
 * happens client-side (substring, forgiving) so those filters stay instant and
 * don't require an exact UUID. Read-only.
 *
 * Lives in `relay/` (not a screen) so the `graphql` tag is confined to modules
 * that go through the Babel transform — screens stay transform-free and testable.
 */
export const auditLogQuery = graphql`
    query auditLogQuery($flag: FeatureKey) {
        auditLog(flag: $flag) {
            id
            action
            target
            oldValue
            newValue
            caller
            whenUtc
        }
    }
`;
